var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-layout"},[_c('header',[_c('top')],1),_vm._v(" "),_c('main',[_c('div',{staticClass:"container"},[_c('nuxt'),_vm._v(" "),_c('LoginModal')],1)]),_vm._v(" "),_c('footer',[_c('footerIndex')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }